<template>
  <div class="app-wrapper" :class="{h100p: minimalistPage}">
    <!--<side-bar></side-bar>-->
    <div class="main-container">
      <nav-bar v-if="!minimalistPage" />
      <!--<tags-view/>-->
      <app-main />
    </div>

    <div v-if="!minimalistPage">
      <p v-if="this.category == 'vitality'" style="text-align: center; color: #464444; margin: 10px 0; font-size: 14px">
        Copyright 2007-{{ this.updateTime }} VITALITY ALL Rights Reserved.
        <a href="http://beian.miit.gov.cn" style="color: #464444; font-size: 14px" target="_blank">京ICP备09007233号-2营业执照</a>
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502039565"
          style="display: inline-block; text-decoration: none; height: 20px; line-height: 30px">
          <img src="../assets/icon.jpg" style="margin: 6px 0px 0 5px; width: 15px; height: auto" />
          <p style="float: left; height: 20px; line-height: 20px; margin: 5px 0px 0px 5px; color: #464444">京公网安备 11010502039565号</p>
        </a>
      </p>
    </div>
  </div>
</template>

<script>
import AppMain from "./components/AppMain.vue";
import NavBar from "./components/NavBar.vue";
import SideBar from "./components/SideBar.vue";
import TagsView from "./components/TagsView/Index.vue";

export default {
  name: "layout",
  components: {
    NavBar,
    SideBar,
    AppMain,
    TagsView,
  },
  data() {
    return {
      category: "",
      updateTime: "",
    };
  },
  computed: {
    minimalistPage() {
      return this.$route.meta.minimalistPage;
    },
  },
  created() {
    this.category = process.env.VUE_APP_TYPE;
  },
  mounted() {
    const nowDate = new Date();
    const date = {
      year: nowDate.getFullYear(),
    };
    this.updateTime = date.year;
  },
};
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  /*height: 100%;*/
  width: 100%;
}
.main-container {
  min-height: 100%;
  background-color: #f2f4f8;
  /*margin-left: 220px;*/
  margin-left: 0px;
  position: relative;
}
</style>
